module.exports = __webpack_public_path__ + "static/media/post_img_3.fb605569.png";